const DEFAULT_ENERGY_UNIT = "MWh";

/**
 * Energy-based sectors store `unit === null` and display in MWh; custom-unit
 * sectors carry a free-text unit (e.g. "Tiere", "ha"). Centralizing the
 * fallback keeps the energy-conversion helpers (which pass non-energy units
 * through unchanged) reading the same value as the column headers.
 */
export const getSectorDisplayUnit = (sector: { unit?: string | null }): string =>
  sector.unit && sector.unit.length > 0 ? sector.unit : DEFAULT_ENERGY_UNIT;
